import { axiosInstanceApiNestingale } from "../../axios";
import handleApiError from "../../utils/handleApiError";

export interface GenerateThreeDModelPayload {
    productSkuId: string;
}

export interface GenerateThreeDModelResponse {
    message: string;
    productSkuId: string;
    threedImage: string;
    status: string;
}

export const threeDModelApi = {
    async generateThreeDModelForPillowAndRug(
        payload: GenerateThreeDModelPayload
    ): Promise<GenerateThreeDModelResponse> {
        try {
            const response =
                await axiosInstanceApiNestingale.post(
                    "v1/api/generateProduct3dGLB",
                    payload
                );
            return response.data;
        } catch (error) {
            throw new Error(handleApiError(error));
        }
    },
};
